var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SPACING_L, SPACING_M, SPACING_S, SPACING_XL } from "../../helpers";
import { useGridContext, useGridResizableContext } from '../features';
import { GRID_COLUMN_JUSTIFY } from '../types';
import { trimmedTextRenderer } from './trimmedTextRenderer';
import * as Svg from '../svg';
export var HeaderCell = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    width: 100%;\n\n    position: relative;\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:active {\n        background-color: ", ";\n    }\n"], ["\n    height: ", ";\n    width: 100%;\n\n    position: relative;\n\n    &:hover {\n        background-color: ",
    ";\n    }\n\n    &:active {\n        background-color: ",
    ";\n    }\n"])), SPACING_XL, function (props) {
    if (props.isSortable) {
        if (props.disabled) {
            return null;
        }
        return props.theme.colorHighlightLight;
    }
    return null;
}, function (props) {
    if (props.isSortable) {
        if (props.disabled) {
            return props.theme.colorBackgroundDisabled;
        }
        return props.theme.colorHighlightDark;
    }
    return null;
});
var justifyContentCss = function (_a) {
    var justify = _a.justify;
    switch (justify) {
        case GRID_COLUMN_JUSTIFY.center:
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                justify-content: center;\n            "], ["\n                justify-content: center;\n            "])));
        case GRID_COLUMN_JUSTIFY.right:
            return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                justify-content: end;\n            "], ["\n                justify-content: end;\n            "])));
        default:
            return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                justify-content: start;\n            "], ["\n                justify-content: start;\n            "])));
    }
};
export var HeaderText = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    max-width: 100%;\n    min-width: 0;\n    ", "\n"], ["\n    display: flex;\n    max-width: 100%;\n    min-width: 0;\n    ",
    "\n"])), function (_a) {
    var hasMarginRight = _a.hasMarginRight;
    return hasMarginRight && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            margin-right: ", ";\n        "], ["\n            margin-right: ", ";\n        "])), SPACING_L);
});
export var HeaderLabel = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", " 0 ", " ", ";\n    color: ", ";\n    box-sizing: border-box;\n\n    display: flex;\n    ", ";\n\n    height: 100%;\n    width: 100%;\n    user-select: none;\n\n    color: ", ";\n\n    ", "\n"], ["\n    padding: ", " 0 ", " ", ";\n    color: ", ";\n    box-sizing: border-box;\n\n    display: flex;\n    ", ";\n\n    height: 100%;\n    width: 100%;\n    user-select: none;\n\n    color: ", ";\n\n    ",
    "\n"])), SPACING_S, SPACING_S, SPACING_S, function (_a) {
    var theme = _a.theme;
    return theme.colorTextMain;
}, justifyContentCss, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled && theme.colorTextLight;
}, function (_a) {
    var disabled = _a.disabled, isInteractive = _a.isInteractive, theme = _a.theme;
    return !disabled &&
        isInteractive && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            &:hover {\n                background-color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n            }\n        "])), theme.colorHighlightLight, theme.colorHighlightDark);
});
export var HeaderSortIndicator = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    min-width: ", ";\n\n    ", "\n"], ["\n    display: flex;\n    min-width: ", ";\n\n    ",
    "\n"])), SPACING_L, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n            polygon {\n                fill: ", ";\n            }\n        "], ["\n            polygon {\n                fill: ", ";\n            }\n        "])), theme.colorControlIconDisabled);
});
export var HeaderResizeIndicator = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 8px;\n\n    cursor: col-resize;\n\n    &:hover,\n    &:active {\n        background-color: ", ";\n    }\n"], ["\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 8px;\n\n    cursor: col-resize;\n\n    &:hover,\n    &:active {\n        background-color: ", ";\n    }\n"])), function (props) { return props.theme.colorHighlightDark; });
export var StyledSortIndicator = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    height: ", ";\n    padding-left: ", ";\n"], ["\n    display: flex;\n    height: ", ";\n    padding-left: ", ";\n"])), SPACING_M, SPACING_S);
export var SortIndicator = function (_a) {
    var direction = _a.direction;
    return (React.createElement(StyledSortIndicator, null,
        direction === 'asc' && React.createElement(Svg.asc, null),
        direction === 'desc' && React.createElement(Svg.desc, null)));
};
export var headerCellId = 'grid-header-cell';
export var headerTextId = 'grid-header-text';
export var headerSortIndicatorId = 'grid-header-sort-indicator';
export var headerResizeIndicatorId = 'grid-header-resize-indicator';
var headerCellRenderer = function (_a) {
    var cellData = _a.cellData, onHeaderClick = _a.onHeaderClick, headerJustify = _a.headerJustify, columnKey = _a.columnKey, columnWidth = _a.columnWidth, columnField = _a.columnField, columnMinWidth = _a.columnMinWidth, columnId = _a.columnId, props = __rest(_a, ["cellData", "onHeaderClick", "headerJustify", "columnKey", "columnWidth", "columnField", "columnMinWidth", "columnId"]);
    var _b = useGridContext().state, sort = _b.sort, resizable = _b.resizable, disabled = _b.disabled;
    var onResizeToggleDown = useGridResizableContext().onResizeToggleDown;
    var isSortable = !!sort;
    var isSortActive = sort && sort.key === columnField;
    return (React.createElement(HeaderCell, { onClick: function () {
            if (onHeaderClick && !disabled)
                onHeaderClick();
        }, isSortable: isSortable && typeof onHeaderClick === 'function', disabled: disabled, "data-selector-id": headerCellId },
        React.createElement(HeaderLabel, { disabled: disabled, isInteractive: !!isSortActive, justify: headerJustify },
            headerJustify === GRID_COLUMN_JUSTIFY.right && (React.createElement("div", { style: { flexGrow: 1, display: 'flex' } })),
            props.contentRenderer ? (props.contentRenderer()) : (React.createElement(HeaderText, { "data-selector-id": headerTextId, hasMarginRight: !isSortActive }, trimmedTextRenderer({
                cellData: cellData,
                columnWidth: columnWidth,
                bold: true,
                disabled: disabled
            }))),
            isSortActive && (React.createElement(HeaderSortIndicator, { "data-selector-id": headerSortIndicatorId, disabled: disabled },
                React.createElement(SortIndicator, { direction: sort && sort.direction })))),
        resizable && !disabled && (React.createElement(HeaderResizeIndicator, { "data-selector-id": headerResizeIndicatorId, onMouseDown: function (e) { return onResizeToggleDown === null || onResizeToggleDown === void 0 ? void 0 : onResizeToggleDown(e, {
                key: columnKey,
                width: columnWidth,
                minWidth: columnMinWidth,
                columnId: columnId
            }); } }))));
};
export default headerCellRenderer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=headerCellRenderer.js.map